import Cookies from 'universal-cookie';

import { GOOGLE_RESERVE_PARTNER_ID } from '@src/constants';
import { useAppStore } from '@src/store';

export const postConversionToGoogle = async (facilityCode?: string) => {
	const googleRestAPIURL = useAppStore.getState().googleUrl;

	const cookies = new Cookies();
	const fcValue = cookies.get('facility-code');

	if (fcValue !== undefined) {
		const fcString = fcValue ? fcValue.toString().trim() : '';

		let rwgValue: string | undefined = cookies.get('_rwg_token');

		if (rwgValue === null || rwgValue === undefined) {
			const urlSearchString = window.location.search;
			const params = new URLSearchParams(urlSearchString);
			rwgValue = params.get('rwg_token') ?? undefined;
		} //verify that the merchant hasn't changed

		const googlePayload = {
			conversion_partner_id: GOOGLE_RESERVE_PARTNER_ID.toString(),
			rwg_token: rwgValue,
			merchant_changed: fcString === facilityCode ? 2 : 1,
		};
		if (rwgValue) {
			try {
				await fetch(googleRestAPIURL, {
					method: 'POST',
					body: JSON.stringify(googlePayload),
				});
			} catch (e) {
				console.error('[postGoogleReserve failed]', e);
			}
		}
		//won't make the call unless the token is coming through via Google Reserve
	}
};
